import { NavLink } from 'react-router-dom'
import { Pin, PinOff } from 'lucide-react'
import { cn } from '@/lib/cn'
import { navItems } from './nav-items'

const sections = [
  { key: 'home', label: null },
  { key: 'my-shooting', label: 'My Shooting' },
  { key: 'my-armoury', label: 'My Armoury' },
  { key: 'competitions', label: 'Competitions' },
  { key: 'social', label: 'Social & Community' },
  { key: 'club-mgmt', label: 'Club Management' },
  { key: 'platform-admin', label: 'Platform Admin' },
] as const

interface SidebarProps {
  pinned: boolean
  onTogglePin: () => void
}

export function Sidebar({ pinned, onTogglePin }: SidebarProps) {
  return (
    <aside
      className={cn('w-64', pinned ? 'block' : 'hidden lg:block')}
      style={{
        background: 'linear-gradient(180deg, #1a1145 0%, #0d0b2e 50%, #0f172a 100%)',
      }}
    >
      <div className="flex h-16 items-center justify-between border-b border-white/10 px-6">
        <span className="text-xl font-bold text-white">Zero</span>
        <button
          onClick={onTogglePin}
          className="rounded-lg p-1.5 text-white/40 hover:bg-white/10 hover:text-white/80 transition-colors"
          aria-label={pinned ? 'Unpin sidebar' : 'Pin sidebar'}
          title={pinned ? 'Unpin sidebar' : 'Pin sidebar'}
        >
          {pinned ? <PinOff className="h-4 w-4" /> : <Pin className="h-4 w-4" />}
        </button>
      </div>
      <nav
        className="overflow-y-auto p-4"
        role="navigation"
        style={{ maxHeight: 'calc(100vh - 4rem)' }}
      >
        {sections.map((section) => {
          const items = navItems.filter((i) => (i.section || 'home') === section.key)
          if (items.length === 0) return null
          return (
            <div key={section.key} className={section.label ? 'mt-4' : ''}>
              {section.label && (
                <p className="mb-1 px-3 text-xs font-semibold uppercase tracking-wider text-white/40">
                  {section.label}
                </p>
              )}
              <ul className="space-y-1">
                {items.map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        cn(
                          'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                          isActive
                            ? 'bg-white/15 text-white'
                            : 'text-white/60 hover:bg-white/10 hover:text-white/90',
                        )
                      }
                    >
                      <item.icon className="h-5 w-5" />
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          )
        })}
      </nav>
    </aside>
  )
}
